import React from 'react';

const NavLifestyle = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 45">
        <path d="M36 36v8.999H8.996L0 45l8.996-9H36zM18 0v27.004L9 36l.002-8.996V0H18z" />
    </svg>
);

export default NavLifestyle;
